type GoogleMapsTokenGlobal = {
  // eslint-disable-next-line no-underscore-dangle
  __jsqGetGoogleMapsBrowserAPIToken__?: () => string;
};

export function initGoogleMaps(googleMapsBrowserApiKey: string): void {
  const token = googleMapsBrowserApiKey;
  const holder: GoogleMapsTokenGlobal = window;
  // eslint-disable-next-line no-underscore-dangle
  holder.__jsqGetGoogleMapsBrowserAPIToken__ = () => token;
}
